import { AUTH_CONTRACT } from '@/api/contracts/auth';
import type { AuthMessage, AuthSession, LoginRequest, RegisterRequest } from '@/types';
import { api } from './client';

export function login(data: LoginRequest): Promise<AuthSession> {
  return api<AuthSession>(AUTH_CONTRACT.login.path, {
    method: AUTH_CONTRACT.login.method,
    body: data,
    skipNonce: true,
    requestSchema: AUTH_CONTRACT.login.schemas.request,
    responseSchema: AUTH_CONTRACT.login.schemas.response,
  });
}

export function register(data: RegisterRequest): Promise<AuthMessage> {
  return api<AuthMessage>(AUTH_CONTRACT.register.path, {
    method: AUTH_CONTRACT.register.method,
    body: data,
    skipNonce: true,
    requestSchema: AUTH_CONTRACT.register.schemas.request,
    responseSchema: AUTH_CONTRACT.register.schemas.response,
  });
}

export function logout(): Promise<AuthMessage> {
  return api<AuthMessage>(AUTH_CONTRACT.logout.path, {
    method: AUTH_CONTRACT.logout.method,
    responseSchema: AUTH_CONTRACT.logout.schemas.response,
  });
}

export function me(): Promise<AuthSession> {
  return api<AuthSession>(AUTH_CONTRACT.me.path, {
    method: AUTH_CONTRACT.me.method,
    responseSchema: AUTH_CONTRACT.me.schemas.response,
  });
}
